import { render } from "./Wheel.vue?vue&type=template&id=c5f332d6&scoped=true"
import script from "./Wheel.vue?vue&type=script&lang=js"
export * from "./Wheel.vue?vue&type=script&lang=js"

import "./Wheel.vue?vue&type=style&index=0&id=c5f332d6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c5f332d6"

export default script